<template>
    <BreadCrumb :items="breadcrumbItems" />
    <main id="main">
        <TermsOfUseForm/>
    </main>
</template>
<script>
import TermsOfUseForm from '@/components/customerService/TermsOfUseForm.vue';
import BreadCrumb from '../layout/navigation/BreadCrumb.vue';

export default {
    data() {
        return {
            breadcrumbItems: [
                { href: "/", text: "홈", isHome: true },
                { href: "#", text: "고객센터" },
            ],
        };
    },
    components: {
        TermsOfUseForm,
        BreadCrumb
    }
}
</script>
<style lang="">
    
</style>